import { SideBarButton } from '../../../settings/nav-list/recursive-sidebar/class/sidebar';
import { PreConfigButton2, PreConfigButton3 } from '../../../settings/nav-list/recursive-sidebar/configuration/preconfig';
import { FILTERS_ROLES_VIEWS_PERMISSIONS } from './roles-actions';

export const FILTERS_SIDENAV_OPTIONS: SideBarButton = {
  data: {
    name: 'Filtros',
    appendUrl: './filters-dep',
    roles: [...FILTERS_ROLES_VIEWS_PERMISSIONS.sideNavActions.root], // ← nuevo
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Proceso',
        url: '/scheduling/production',
        roles: [
          ...FILTERS_ROLES_VIEWS_PERMISSIONS.sharedActions
            .schedulingTypeIdProduction,
        ],
        otherUniqueUrls: ['/scheduling/packing'],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'QC',
        url: '/quality-control',
        roles: [
          ...FILTERS_ROLES_VIEWS_PERMISSIONS.sharedActions.addInspectionSheets,
        ],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Validacion',
        url: '/validation',
        roles: [
          ...FILTERS_ROLES_VIEWS_PERMISSIONS.sharedActions.validationTypeId,
        ],
      },
      options: PreConfigButton3,
    },

    {
      data: {
        name: 'Etiquetas',
        url: '/packing-box',
        roles: [...FILTERS_ROLES_VIEWS_PERMISSIONS.sharedActions.packingBox],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Planeación diaria',
        overWriteUrl: './daily-planning/Filter/current',
        roles: [...FILTERS_ROLES_VIEWS_PERMISSIONS.sharedActions.dailyPlanning],
      },
      options: PreConfigButton3,
    },
    // {
    //   data: {
    //     name: 'Eficiencia',
    //     overWriteUrl: './efficiencies/Filter/records',
    //     roles: [...filtersAccioneRoles.sharedActions.efficiency],
    //   },
    //   options: PreConfigButton3,
    // },

    {
      data: {
        name: 'Agregar Datos QC',
        url: '/qc-data',
        roles: [
          ...FILTERS_ROLES_VIEWS_PERMISSIONS.sharedActions.addInspectionSheets,
        ],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Reporte Power BI',
        overWriteUrl: './reportsPBI/filters',
        roles: [
          ...FILTERS_ROLES_VIEWS_PERMISSIONS.sideNavActions.reportsPbiFilters,
        ],
      },
      options: PreConfigButton3,
    },
  ],
};
